import React from "react";
import SiteHeader from "@/components/layout/site-header";
import { Banner } from "@/features/banner";

const MainNavLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <div className="w-full h-full mx-auto flex flex-col">
      <Banner />
      <SiteHeader />
      <main className="flex-1 overflow-hidden p-6">
        {children}
      </main>
    </div>
  )
}

export default MainNavLayout;
